module.exports = __webpack_public_path__ + "static/animation-191b5b5933558cb28f99c4a608d04046.gif";